import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Button } from '@mui/material'
import { FC } from 'react'
import { TopToolbar, useTranslate } from 'react-admin'
import { Link } from 'react-router-dom'

import type { TranslationKey } from '@/i18n'

export const BackButton: FC<{ to: string; label: TranslationKey }> = ({ to, label }) => {
  const translate = useTranslate()
  return (
    <TopToolbar sx={{ justifyContent: 'flex-start' }}>
      <Button variant="text" color="inherit" component={Link} to={to} startIcon={<ArrowBackIcon />} sx={{ textTransform: 'none' }}>
        {translate(label)}
      </Button>
    </TopToolbar>
  )
}
